'use client';

import { Candidate, EventProps } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';
import { rotateImageToPortrait } from '~/utils/rotateImageToPortrait';

const onFieldValueChange = async (event: EventProps) => {
    const { candidateStore } = getStore();
    const { name, type, value, files } = event.target as HTMLInputElement;
    const selectedCandidateEdit = candidateStore.selectedCandidateEdit;

    if (type === 'file') {
        const file = files?.[0];
        if (!file) return;

        // Since we only use file input for uploadinng candidate we don't dynamically check file type at this moment.
        const acceptedTypes = ['image/gif', 'image/jpeg', 'image/jpg'];
        const filtered = Array.from(files).filter((file) => acceptedTypes.includes(file.type));
        if (filtered.length !== files.length) {
            alert('Bilde (filtype .jpg eller .gif)');
            return;
        }

        // Rotate file if needed
        const rotatedFile = await rotateImageToPortrait(file);

        // Store file for preview instead of uploading immediately
        candidateStore.setPreviewCandidatePhoto(rotatedFile);

        // Create a preview URL for the image
        const previewUrl = URL.createObjectURL(rotatedFile);
        candidateStore.setCandidatePhoto({
            name: rotatedFile.name,
            url: previewUrl,
        });
        return;
    }

    candidateStore.setSelectedCandidateEdit(<Candidate>{
        ...selectedCandidateEdit,
        [name]: type === 'checkbox' ? (event.target as HTMLInputElement).checked : value,
    });
};

export default onFieldValueChange;
